




















































import { Vue, Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { ExternalValidationResults } from "../../../domain/document";
import {
  HeaderPane,
  LeftSidePane,
  RightSidePane,
  ContentPane,
} from "./panes";
import { IToolTabDefinition } from "./contents";
import { ITabDefinition } from "./contents/tools";
import CommonComponentsContainer from "./CommonComponentsContainer.vue";
import { ICommonComponentsContainable } from "./ICommonComponentsContainable";
import { DocumentEditorMixin } from "./mixins";
import { EditingDocument } from "./";
import { IHisInformationAccessible } from "../../../domain/his";
import { FixedLoading } from "../../system";
import { SystemLogger } from "../../../domain/system";

@Component({
  components: {
    HeaderPane,
    LeftSidePane,
    RightSidePane,
    ContentPane,
    CommonComponentsContainer,
    FixedLoading,
  },
})
export default class DocumentEditor extends Mixins(DocumentEditorMixin) implements ICommonComponentsContainable {
  getCommonComponentsContainer(): Vue {
    return this.$refs.commonComponents as Vue;
  }

  @Prop({ default: false })
  isEmbedded: boolean;

  @Prop()
  defaultToolTabName: string;

  @Prop()
  additionalToolTabs: IToolTabDefinition[];

  @Prop()
  additionalDocumentViewToolTabs: ITabDefinition[];

  @Prop({ default: false })
  hasAdditionalComments: boolean;

  @Prop({ default: false })
  shouldValidateExistingLinkedDocument: boolean;

  @Prop()
  validateWithExternalValidationUrl: () => Promise<ExternalValidationResults>;

  @Prop()
  hisInformationAccessor: IHisInformationAccessible;

  data() {
    return {
      isWindowClosing: false,
    };
  }
  isWindowClosing: boolean;

  mounted() {
    this.$registerCloseHandler(this.deleteCreateToken);
    this.$registerDocumentRegisterAsTemporaryBeforeCloseHandler(this.registerDocumentAsTemporaryBeforeClose);
  }

  destroyed() {
    this.$registerDocumentRegisterAsTemporaryBeforeCloseHandler(async (isForcibly: boolean) => {});
  }

  private async registerDocumentAsTemporaryBeforeClose(isForcibly: boolean): Promise<void> {
    if (!this.isDocumentInitialized || this.isWindowClosing) { return; }
    this.isWindowClosing = true;
    
    const isConfirmed = isForcibly
      ? true
      : await this.confirmRegisterAsTemporaryBeforeClose();
    if (isConfirmed) {
      this.$logger.info("文書の強制一時保存を開始します。");
      const id = await this.commonComponents.operators.registerer.registerDocumentAsTemporaryForcibly();
      this.$logger.info("文書の強制一時保存が完了しました。");
      if (isForcibly) {
        this.$info("一時保存", "文書の一時保存が完了しました。自動的にウィンドウを閉じます。");
      }
      await SystemLogger.info("終了連携により文書を一時保存しました。DocumentId=" + id, this.document.attributes.patient.id);
      // 通知などが終わるまで待つ
      await this.$sleep(2000);
    }
  }

  private async confirmRegisterAsTemporaryBeforeClose(): Promise<boolean> {
    try {
      const index = await this.$commonDialogs.confirmation.show({
        title: "確認",
        message: ["ウィンドウを閉じる前に編集中の文書を一時保存しますか？"],
        buttons: [
          {
            kind: "confirm",
            label: "一時保存して閉じる",
          }, 
          {
            kind: "danger",
            label: "一時保存しないで閉じる",
          }, 
        ],
        cancellation: {
          isEnable: false,
        },
      });
      return (index === 0);
    } catch (e) {
      return false;
    }
  }

  onDocumentRegistered(id: number, destinationRoute?: any, isTemporary?: boolean, archiveId?: number) {
    this.clearCreateTokenTimer();
    this.clearWriteTokenTimer();
    this.documentRegistered(id, destinationRoute, isTemporary, archiveId, this.isWindowClosing);
  }

  async deleteCreateToken(): Promise<void> {
    this.clearCreateTokenTimer();
    await this.deleteDocumentCreateToken();
  }

  /**
   * DocumentEditorMixinに移動してdestroyed()からも呼ぶようにしたほうが安全なように見える
   */
  clearCreateTokenTimer(): void {
    if (!this.createTokenTimer) { return; }
    clearInterval(this.createTokenTimer);
    this.createTokenTimer = null;
  }

  @Watch("document")
  onDocumentUpdated(newValue: EditingDocument, oldValue: EditingDocument) {
    if (!oldValue && newValue) {
      if (newValue.source && newValue.source.unmanagedInformation && this.redirectUneditableDocument) {
        this.redirectUneditableDocument(newValue.source);
      }
    }
  }
}
